module.exports = __webpack_public_path__ + "static/lillie-f30b6fac82503cc213e2c4c605dcd9ad.png";